import { PartFinderExportSelection, usePartFinderExport } from '@/hooks/api/part-finder-reports/usePartFinderExport';
import { FileDownloadOutlined } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';

export const PartFinderExportButton = ({
  reportIds,
  batchIds,
  tooltip = 'Export to Excel',
}: PartFinderExportSelection & { tooltip?: string }) => {
  const { exportToExcel, isExporting } = usePartFinderExport();

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size='small'
          aria-label={tooltip}
          disabled={isExporting}
          onClick={() => void exportToExcel({ reportIds, batchIds })}
        >
          {isExporting ? <CircularProgress size={18} /> : <FileDownloadOutlined fontSize='small' />}
        </IconButton>
      </span>
    </Tooltip>
  );
};
